import { render } from "./orderServeItemTmp.vue?vue&type=template&id=7b8a8ca2"
import script from "./orderServeItemTmp.vue?vue&type=script&lang=js"
export * from "./orderServeItemTmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__